import React from 'react';
import ProductGroupListView from 'domains/productGroup/components/ProductGroupListView';

const ProductGroupListPage: React.FC = () => {
  return <ProductGroupListView />;
};

export default ProductGroupListPage;
